import { gql } from 'urql'

export const queryHelpInstructionLinks = gql`
  query ($helpInstructionsConfigCondition: help_and_instruction_link_bool_exp, $offset: Int!, $limit: Int!) {
    help_and_instruction_link(
      where: $helpInstructionsConfigCondition
      offset: $offset
      limit: $limit
      order_by: [{ help_and_instruction_name_locale: asc }, { id: asc }]
    ) {
      id
      help_and_instruction_name_locale
      links
      location_hints
    }
    help_and_instruction_link_aggregate(where: $helpInstructionsConfigCondition) {
      aggregate {
        count
      }
    }
  }
`

export const queryHelpInstructionLinkById = gql`
  query ($helpInstructionId: Int!) {
    help_and_instruction_link(where: { id: { _eq: $helpInstructionId } }) {
      id
      key
      labels
      links
      location_hints
    }
  }
`

export const insertHelpInstructionLink = gql`
  mutation ($helpInstructionsInsertInput: [help_and_instruction_link_insert_input!]!) {
    insert_help_and_instruction_link(objects: $helpInstructionsInsertInput) {
      affected_rows
    }
  }
`

export const updateHelpInstructionLinkById = gql`
  mutation ($helpInstructionId: Int!, $helpInstructionsSetInput: help_and_instruction_link_set_input!) {
    update_help_and_instruction_link(where: { id: { _eq: $helpInstructionId } }, _set: $helpInstructionsSetInput) {
      affected_rows
    }
  }
`

export const deleteHelpInstructionLinkById = gql`
  mutation ($helpInstructionId: Int!) {
    delete_help_and_instruction_link(where: { id: { _eq: $helpInstructionId } }) {
      affected_rows
    }
  }
`
